export function eliminarPlanAdminService(url, token, idPlan) { //El id de la empresa es el id del usuario

  return new Promise((resolve, reject) => {
    var res = fetch(url + 'plans/'+idPlan, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': '*/*',
        'Authorization': token
      }
    })
      .then(function (response) {
        let status = response.status;
        let res = {ok: response.ok, error: status};
        if(status !== 401){
          return response.json();
        } else if(status === 401){
          return res;
        }
      })
      .then(function (responser) {
        return responser;
      }).catch((error) => {
        return error;
      });
    res ? resolve(res) : reject('error-');
  });
}
